import { formatBackEndWeightToSystem, convertKgToLbs } from 'utils/weightHelper';

// Quantities are stored in lbs on the backend; caregivers enter tons (imperial) or kg (metric)

export const lbsToDisplay = (lbs, measurementSystem) => {
  if (lbs === null || lbs === undefined) return null;
  if (measurementSystem === 'metric') return Math.round(formatBackEndWeightToSystem(lbs, 'metric') * 100) / 100;
  return Math.round((lbs / 2000) * 100) / 100;
};

export const displayToLbs = (value, measurementSystem) => {
  if (measurementSystem === 'metric') return convertKgToLbs(Number(value));
  return Number(value) * 2000;
};

export const weightUnit = (measurementSystem) => (measurementSystem === 'metric' ? 'kg' : 'tons');
